<script>
import Constants from '../constants';

import commonFooter from '@/components/commonFooter';
import commonNav from '@/components/commonNav';
import shareBtn from '@/components/shareBtn';

import setMetaUtil from '@/util/setMetaUtil';

export default {
  name: Constants.ROUTER.ABOUTSITE,
  components: {
    commonFooter,
    commonNav,
    shareBtn,
  },
  data() {
    return {
      ready: false,
      windowHeight: Constants.WINDOW.MIN_HEIGHT.viewSm,

      contactDesc: '',
    };
  },
  created() {
    setMetaUtil.setMeta(this, document,
      `${this.$i18n.messages.ja.message.aboutSite.pageName} - ${this.$i18n.messages.ja.message.bandName}`,
      this.$i18n.messages.ja.message.aboutSite.description,
    );
    document.dispatchEvent(new Event('custom-render-trigger'));

    window.onscroll = () => { this.onscroll(); }
    window.onresize = () => { this.onscroll(); }
    this.onscroll();

    this.contactDesc = this.$t('message.aboutSite.data.contactDesc', {
      mail: this.$t('message.mailAddress'),
      twitterSnsName: this.$t('message.snsName.twitter'),
      twitterUrl: Constants.SNS.TWITTER,
      twitterId: Constants.SNS.TWITTER_ID,
    });

    setTimeout(()=> {
      this.ready = true;
    }, 1);
  },
  methods: {
    onscroll() {
      const minHeight = Constants.WINDOW.MIN_HEIGHT[this.$mq];
      this.windowHeight = window.innerHeight < minHeight ? minHeight : window.innerHeight;
    },
  }
};
</script>

<template>
  <div class="view-aboutsite page" :class="ready ? 'is-ready' : ''">
    <common-nav/>
    <div id="contents-main" :style="{'min-height': windowHeight + 'px'}">
      <div class="page-title-container">{{$t('message.aboutSite.pageName')}}</div>

      <div class="title-container">{{$t('message.aboutSite.data.aboutLyrics')}}</div>
      <div class="desc-container" v-html="$t('message.aboutSite.data.aboutLyricsDesc')"></div>

      <div class="title-container">{{$t('message.aboutSite.data.aboutDistribution')}}</div>
      <div class="desc-container" v-html="$t('message.aboutSite.data.aboutDistributionDesc')"></div>

      <div class="title-container">{{$t('message.aboutSite.data.aboutLink')}}</div>
      <div class="desc-container" v-html="$t('message.aboutSite.data.aboutLinkDesc')"></div>
      
      <div class="title-container">{{$t('message.aboutSite.data.banner')}}</div>
      <div class="desc-container">
        <img :src="$t('message.aboutSite.data.bannerUrl')">
      </div>

      <div class="title-container">{{$t('message.aboutSite.data.contact')}}</div>
      <div class="desc-container" v-html="contactDesc"></div>
    </div>
    <common-footer/>
    <share-btn :is-fixed="true"/>
  </div>
</template>

<style lang="scss">
  @import "../css/variables";
  .page {
    position: relative;
    #contents-main {
      padding-top: $commonNavHeight;
      padding-top: 50px;
      text-align: center;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      // 中央寄せ
      justify-content: center;
      align-items: center;
      .page-title-container, .title-container, .desc-container {
        text-align: left;
        word-break: break-all;
        max-width: 500px;
      }
      .page-title-container {
        margin-bottom: 20px;
      }
      .title-container {
        margin-bottom: 5px;
      }
      .desc-container {
        font-size: 0.8em;
        margin-bottom: 50px;
        // scopedにするとv-html内のタグにcssがあたらない
        a {
          @include normalTextLink;
        }
      }
    }
  }
</style>
